module.exports = __webpack_public_path__ + "assets/fonts/element-icons.732389de.ttf";